import React from "react";
import Carousel from "./Carousel";

const chunkData = (data: any[], size: number) => {
    const chunks = [];
    for (let i = 0; i < data.length; i += size) {
        chunks.push(data.slice(i, i + size));
    }
    return chunks.length > 0 ? chunks : [data];
};

const MyPageSection = ({
    sectionKey,
    title,
    icon,
    data,
    mode
}: {
    sectionKey: string;
    title: string;
    icon: string;
    data: any[];
    mode: string;
}) => {
    const grouped = chunkData(data, 3);

    return (
        <section className={`section-${sectionKey} info-dispaly`}>
            <div className="container">
                <h1 className="text-xs text-center">
                    <img src={`/assets/images/other/${icon}`} className="img img-fluid mb-2 mr-2 height-35" />
                    {title}
                </h1>
                <div className="carousel-wrapper">
                    <Carousel id={`carousel-${sectionKey}`} groups={grouped} mode={mode} />
                </div>
            </div>
        </section>
    );
};

export default MyPageSection;
